module.exports = __webpack_public_path__ + "public/img/img_2.f4296cc8.jpg";